import { toast } from "react-toastify";
import axiosInstance from "../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../Base/helper/baseFunctions";


export const GetCanteenManagementRegionHelper = async (params) => {
    return await axiosInstance(`/canteen/getCanteenManagementRegion`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
        }
    })
    .then((res) => {
        return { message: "Regions retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        return { message: "Unable to retrieve regions", hasError: true, data: err?.response?.data }
    });
};

export const AddCanteenManagementRegionHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/canteen/addCanteenManagementRegion`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            region: params?.region,

        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Region added successfully");
        return { message: "Region added successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to add region", hasError: true, data: err?.response?.data }
    });
};

export const UpdateCanteenManagementRegionHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/canteen/updateCanteenManagementRegion`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            region: params?.region,
            canteen_management_regions_pk: params?.canteen_management_regions_pk,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Region updated successfully");
        return { message: "Region updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update region", hasError: true, data: err?.response?.data }
    });
};

export const DeleteCanteenManagementRegionHelper = async (params) => {
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/canteen/deleteCanteenManagementRegion`, {
        method: "DELETE",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            canteen_management_regions_pk: params?.canteen_management_regions_pk,

        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Region deleted successfully");
        return { message: "Region deleted successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to delete region", hasError: true, data: err?.response?.data }
    });
};
